import React, { useState, useEffect } from "react";
import "./style.less";
import PaginationComponent from "../PaginationComponent/PaginationComponent";
import TvAdsItem from "../TvAdsItem/TvAdsItem";

import { Col, Row } from "react-bootstrap";
import JobApplyModel from "../JobApplyModel/JobApplyModel";
import TvAdsModel from "../TvAdsModel/TvAdsModel";
import itemImg from "../../images/events/thumb.png";
import sliderImg from "../../images/events/sliderImg.png";

import calender from "../../images/events/calender.svg";
import clock from "../../images/events/clock.svg";
import location from "../../images/events/location.svg";
import gallery from "../../images/events/gallery.svg";
import useWindowDimensions from "../../useWindowDimensions";
import EventsModelSlider from "../EventsModelSlider/EventsModelSlider";

const eventsArr = [
  {
    img: itemImg,
    date: "December 5, 2020",
    time: "6:00 pm - 8:00 pm",
    location: "New York",
    title: "Lorem ipsum dolor sit amet, consetetur sadipscing elitr",
    desc:
      "Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy lorem ipsum dolor sit amet, consetetur sadipscing",
  },
  {
    img: itemImg,
    date: "December 5, 2020",
    time: "6:00 pm - 8:00 pm",
    location: "New York",
    title: "Lorem ipsum dolor sit amet, consetetur sadipscing elitr",
    desc:
      "Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy lorem ipsum dolor sit amet, consetetur sadipscing",
  },
  {
    img: itemImg,
    date: "December 5, 2020",
    time: "6:00 pm - 8:00 pm",
    location: "New York",
    title: "Lorem ipsum dolor sit amet, consetetur sadipscing elitr",
    desc:
      "Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy lorem ipsum dolor sit amet, consetetur sadipscing",
  },
  {
    img: itemImg,
    date: "December 5, 2020",
    time: "6:00 pm - 8:00 pm",
    location: "New York",
    title: "Lorem ipsum dolor sit amet, consetetur sadipscing elitr",
    desc:
      "Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy lorem ipsum dolor sit amet, consetetur sadipscing",
  },
  {
    img: itemImg,
    date: "December 5, 2020",
    time: "6:00 pm - 8:00 pm",
    location: "New York",
    title: "Lorem ipsum dolor sit amet, consetetur sadipscing elitr",
    desc:
      "Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy lorem ipsum dolor sit amet, consetetur sadipscing",
  },
  {
    img: itemImg,
    date: "December 5, 2020",
    time: "6:00 pm - 8:00 pm",
    location: "New York",
    title: "Lorem ipsum dolor sit amet, consetetur sadipscing elitr",
    desc:
      "Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy lorem ipsum dolor sit amet, consetetur sadipscing",
  },
  {
    img: itemImg,
    date: "December 5, 2020",
    time: "6:00 pm - 8:00 pm",
    location: "New York",
    title: "Lorem ipsum dolor sit amet, consetetur sadipscing elitr",
    desc:
      "Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy lorem ipsum dolor sit amet, consetetur sadipscing",
  },
  {
    img: itemImg,
    date: "December 5, 2020",
    time: "6:00 pm - 8:00 pm",
    location: "New York",
    title: "Lorem ipsum dolor sit amet, consetetur sadipscing elitr",
    desc:
      "Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy lorem ipsum dolor sit amet, consetetur sadipscing",
  },
  {
    img: itemImg,
    date: "December 5, 2020",
    time: "6:00 pm - 8:00 pm",
    location: "New York",
    title: "Lorem ipsum dolor sit amet, consetetur sadipscing elitr",
    desc:
      "Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy lorem ipsum dolor sit amet, consetetur sadipscing",
  },
  {
    img: itemImg,
    date: "December 5, 2020",
    time: "6:00 pm - 8:00 pm",
    location: "New York",
    title: "Lorem ipsum dolor sit amet, consetetur sadipscing elitr",
    desc:
      "Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy lorem ipsum dolor sit amet, consetetur sadipscing",
  },
  {
    img: itemImg,
    date: "December 5, 2020",
    time: "6:00 pm - 8:00 pm",
    location: "New York",
    title: "Lorem ipsum dolor sit amet, consetetur sadipscing elitr",
    desc:
      "Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy lorem ipsum dolor sit amet, consetetur sadipscing",
  },
  {
    img: itemImg,
    date: "December 5, 2020",
    time: "6:00 pm - 8:00 pm",
    location: "New York",
    title: "Lorem ipsum dolor sit amet, consetetur sadipscing elitr",
    desc:
      "Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy lorem ipsum dolor sit amet, consetetur sadipscing",
  },
  {
    img: itemImg,
    date: "December 5, 2020",
    time: "6:00 pm - 8:00 pm",
    location: "New York",
    title: "Lorem ipsum dolor sit amet, consetetur sadipscing elitr",
    desc:
      "Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy lorem ipsum dolor sit amet, consetetur sadipscing",
  },
  {
    img: itemImg,
    date: "December 5, 2020",
    time: "6:00 pm - 8:00 pm",
    location: "New York",
    title: "Lorem ipsum dolor sit amet, consetetur sadipscing elitr",
    desc:
      "Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy lorem ipsum dolor sit amet, consetetur sadipscing",
  },
];

const Events = (props) => {
  const { height, width } = useWindowDimensions();

  const [totalPages, setTotalPage] = useState(10);
  const [selectedPage, setSelectedPage] = useState(0);
  const [totalPageArray, setTotalPageArray] = useState([]);
  const [metaData, setMetaData] = useState({});
  const [pgLoading, setPgLoading] = useState(true);
  const [loading, setLoading] = useState(true);
  const [modalShow, setModalShow] = useState(false);
  const [playVideo, setPlayVideo] = useState(false);
  const [youtubeId, setYoutubeId] = useState("");

  const [selectedArray, setSelectedArray] = useState([]);
  const [totalSlicePageArray, settotalSlicePageArray] = useState([]);

  useEffect(() => {
    setSelectedPage(0);
    document.title = "Hos - Media (Events)";
    if (width < 1024) {
      setTotalPage(Math.ceil(eventsArr.length / 4));
      let temp = [];

      for (let i = 1; i <= Math.ceil(eventsArr.length / 4); i++) {
        temp.push(i);
      }
      setTotalPageArray(...[temp]);

      settotalSlicePageArray(...[temp.slice(0, 3)]);

      let pagestart = 0;
      let temp2 = [...eventsArr];
      setSelectedArray(temp2.slice(pagestart, pagestart + 4));
    } else {
      setTotalPage(Math.ceil(eventsArr.length / 6));

      let temp = [];

      for (let i = 1; i <= Math.ceil(eventsArr.length / 6); i++) {
        temp.push(i);
      }
      setTotalPageArray(...[temp]);
      settotalSlicePageArray(...[temp.slice(0, 3)]);

      let pagestart = 0;
      let temp2 = [...eventsArr];
      setSelectedArray(temp2.slice(pagestart, pagestart + 6));
    }
  }, []);

  useEffect(() => {
    if (width < 1024) {
      let pagestart = selectedPage * 4;
      let temp = [...eventsArr];
      setSelectedArray(temp.slice(pagestart, pagestart + 4));
    } else {
      let pagestart = selectedPage * 6;
      let temp = [...eventsArr];
      setSelectedArray(temp.slice(pagestart, pagestart + 6));
    }
    leftArrowClickOpacityHandle();
    rightArrowClickOpacityHandle();
  }, [selectedPage]);

  const leftArrowClickOpacityHandle = () => {
    if (selectedPage === 0) {
      try {
        document.getElementById("paginationLeftarrow").style.opacity = ".5";
        document.getElementById("paginationLeftarrow").style.cursor = "initial";
      } catch (error) {}
    } else {
      try {
        document.getElementById("paginationLeftarrow").style.opacity = "1";
        document.getElementById("paginationLeftarrow").style.cursor = "pointer";
      } catch (error) {}
    }
  };

  const rightArrowClickOpacityHandle = () => {
    if (totalPages === selectedPage + 1) {
      try {
        document.getElementById("paginationrightarrow").style.opacity = ".5";
        document.getElementById("paginationrightarrow").style.cursor =
          "initial";
      } catch (error) {}
    } else {
      try {
        document.getElementById("paginationrightarrow").style.opacity = "1";
        document.getElementById("paginationrightarrow").style.cursor =
          "pointer";
      } catch (error) {}
    }
  };

  const leftArrowClick = () => {
    if (!(selectedPage - 1 < 0)) {
      //   ////console.log("total page", totalPageArray.length)
      //   ////console.log("current page", selectedPage)
      //   ////console.log("total page-2", totalPageArray.length - 2)
      //   ////console.log("==>", totalPageArray.length - 2 >= selectedPage)

      if (totalPageArray.length - 2 >= selectedPage) {
        settotalSlicePageArray(
          totalPageArray.slice(selectedPage - 1, selectedPage + 2)
        );
      }

      setSelectedPage(selectedPage - 1);
      scrollToDiv();
    }
  };
  const nextArrowClick = () => {
    if (selectedPage + 1 !== totalPageArray.length) {
      if ((selectedPage + 1) % 2 === 0 || selectedPage >= 2) {
        settotalSlicePageArray(
          totalPageArray.slice(selectedPage, selectedPage + 3)
        );
      }

      setSelectedPage(selectedPage + 1);

      scrollToDiv();
    }
    // totalPageArray.length === (selectedPage+1) ?null :
  };
  const scrollToDiv = () => {
    const id = "list";
    const yOffset = -170;
    const element = document.getElementById(id);
    const y =
      element.getBoundingClientRect().top + window.pageYOffset + yOffset;

    window.scrollTo({ top: y, behavior: "smooth" });
  };

  const paginationNoClick = (i) => {
    setSelectedPage(i - 1);
    scrollToDiv();
  };

  const seePhotosClick = (id) => {
    setYoutubeId(id);
    setModalShow(true);
  };

  const eventslist = selectedArray.map((item, i) => {
    return (
      <div key={i}>
        {i === 0 && selectedPage === 0 ? (
          <div className="title">UPCOMING EVENTS</div>
        ) : null}
        {i === 3 && selectedPage === 0 ? (
          <div className="title">PAST EVENTS</div>
        ) : null}
        <div
          style={
            i === 2 && selectedPage === 0 ? { borderBottom: "none" } : null
          }
          className="eventItemrow"
        >
          <div className="p-r">
            <img src={item.img} className="itemImg" />
            <div className="seePhotosContainer d-f">
              <img src={gallery} className="galleryIcon" />
              <div onClick={() => seePhotosClick(i)} className="seePhotostxt">
                See Photos
              </div>
            </div>
          </div>

          <div className="descContainer">
            <div className="itemTitle">{item.title}</div>
            <div className="d-f dateContainer">
              <div className="d-f">
                <div>
                  <img src={calender} className="img-fluid calender" />
                </div>
                <div className="dateTxt"> {item.date}</div>
              </div>
              <div className="d-f timeContainer">
                <div>
                  <img src={clock} className="img-fluid calender" />
                </div>
                <div className="dateTxt"> {item.time}</div>
              </div>
              <div className="d-f timeContainer">
                <div>
                  <img src={location} className="img-fluid calender " />
                </div>
                <div className="dateTxt td-un"> {item.location}</div>
              </div>
            </div>
            <div className="itemDec">{item.desc}</div>
          </div>
        </div>
      </div>
    );
  });
  // sliderImg
  return (
    <>
      <div id="list" className="events">
        <div>{eventslist}</div>

        {totalPageArray.length === 1 ? null : (
          <div className="d-f j-c a-c productListPaginationContainer">
            <div onClick={leftArrowClick} id="paginationLeftarrow">
              Prev
            </div>
            <PaginationComponent
              // paginationNoClick={(item) => paginationNoClick(item)}
              paginationNoClick={(item) => paginationNoClick(item)}
              totalPageArray={totalSlicePageArray}
              selectedPage={selectedPage}
            />

            <div onClick={nextArrowClick} id="paginationrightarrow">
              Next
            </div>
          </div>
        )}
      </div>

      <EventsModelSlider
        show={modalShow}
        props={props}
        youtubeId={youtubeId}
        playVideo={playVideo}
        onClickVideo={() => setPlayVideo(true)}
        onHide={() => setModalShow(false)}
      />
    </>
  );
};

export default Events;
